import React, { Component } from "react";
import { WarehouseService } from "../Services/WarehouseService";
import { toInt, formatNumber} from "../Utils";
import { ProductService } from "../Services/ProductService";
import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import EnhancedTableHead from "../components/EnhancedTableHead";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import XLSX from 'xlsx';
import { withStyles, TableRow, TableCell, TableBody, TextField, Table, Fade, CircularProgress } from "@material-ui/core";
import { UserService } from "../Services/UserService";
import { Autocomplete } from "@material-ui/lab";

const styles = theme => ({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        paddingTop : theme.spacing(1), 
        paddingLeft: theme.spacing(1), 
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    margin: {
        margin: theme.spacing(1),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    tablecell: {
        fontSize: '12pt',
        padding: theme.spacing(1),
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    table: {
        display: 'inline-block',  
        [theme.breakpoints.up('md')]: {
            minWidth: 500,
            display: 'inline-table',  
        },
        overflow: 'auto',
        marginTop: 20,
        marginBottom: 20
    },
  });

class InventoryStockSummary extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            modal: { title: '', rows: []},
            message: undefined,
            master_products: [],
            columns : [
                { id: 'index', numeric: false, disablePadding: true, label: '', sortable: false },
                { id: 'name', numeric: false, disablePadding: true, label: 'Product', sortable: true },
                { id: 'unit', numeric: false, disablePadding: true, label: 'Unit', sortable: false },
				{ id: 'fresh_stock', numeric: true, disablePadding: true, label: 'Fresh Stock available' , sortable: true },
				{ id: 'return_stock', numeric: true, disablePadding: true, label: 'Return Stock available' , sortable: true },
				{ id: 'total_value_fresh', numeric: true, disablePadding: true, label: 'Total Amount Fresh', sortable: true  },
				{ id: 'total_value_return', numeric: true, disablePadding: true, label: 'Total Amount Return', sortable: true  }
			],
			order: 'asc',
			orderBy: 'name',
            selected_source: "",
            searchText: "",
            loading: false,
            source_names: []
        }
    }

    componentDidMount(){
        this.props.setTitle('Stock Summary');
        this.fetchSource();
    }

    refresh = () => {
        this.fetchStock(this.state.selected_source);
    }

    exportReport = (e) => {
        let {items, selected_source} = this.state;
        items = items.filter((i) => i.source_id === selected_source.id);
        if(items && items.length > 0){
            const wb = XLSX.utils.book_new();
            let sheetname = selected_source.value;
            let exportData = [["Sl.no", "Product", "Unit", "Fresh Stock available", "Return Stock available", "Total Amount Fresh", "Total Amount Return"]];
            items.forEach((row, i) => {
                let r = [ i+1, row.name, row.unit_size, row.fresh_stock, row.return_stock, row.fresh_stock * row.unit_price, row.return_stock * row.unit_price];
                exportData.push(r);
            });

            const wsAll = XLSX.utils.aoa_to_sheet(exportData);
            XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
            XLSX.writeFile(wb, `Inventory summary - ${selected_source.value}.xlsx`);
        } else {
            this.props.showSnackBar('Nothing to export', 'error');
        }
  	}

    fetchStock = (source) => {
        this.props.isLoading(true);
        this.setState({loading: true});
        WarehouseService.getStock(source.id)
        .then((data) => {
            console.log(source, data);
            this.setState({loading: false});
            let items = [];

            this.state.master_products.forEach(product => {                    
                let fresh_stock = data.stock.filter(s => s.source_id === source.id && source.type === s.source_type && s.product_id === product.id && s.stock_type === 'FRESH');
                let return_stock = data.stock.filter(s => s.source_id === source.id && source.type === s.source_type && s.product_id === product.id && s.stock_type === 'RETURN');
                let unit_price = product.unit_price ? parseFloat(product.unit_price) : 0;
                items.push({
                    source_type: source.type,
                    source_id: source.id,
                    product_id: product.id,
                    name: product.display_name ? product.display_name : product.name,
                    fresh_stock: fresh_stock.length > 0 ? toInt(fresh_stock[0].qty) : 0,
                    return_stock: return_stock.length > 0 ? toInt(return_stock[0].qty) : 0,
                    unit_price: unit_price,
                    status: toInt(product.status),
                    unit_size: product.unit_size
                });
            });
            console.log(items);
            this.updateRows(items);
            this.setState({items: items, original_items: items, searchText: ''});
            // this.state.master_source.forEach(source => {
            //     this.state.master_products.forEach(product => {                    
            //         let fresh_stock = data.stock.filter(s => s.source_id === source.id && s.product_id === product.id && s.stock_type === 'FRESH');
            //         let return_stock = data.stock.filter(s => s.source_id === source.id && s.product_id === product.id && s.stock_type === 'RETURN');
            //         let unit_price = product.unit_price ? parseFloat(product.unit_price) : 0;
            //         items.push({
            //             source_type: source.type ? "AGENT": "WAREHOUSE",
            //             source_id: source.id,
            //             product_id: product.id,
            //             name: product.display_name ? product.display_name : product.name,
            //             fresh_stock: fresh_stock.length > 0 ? toInt(fresh_stock[0].qty) : 0,
            //             return_stock: return_stock.length > 0 ? toInt(return_stock[0].qty) : 0,
            //             unit_price: unit_price,
            //             status: toInt(product.status),
            //             unit_size: product.unit_size
            //         });
            //     });
            // });

            // this.setState({items: items, original_items: items, searchText: ''}, () => {
            //     let source = this.state.selected_source;
            //     if(!this.state.selected_source){
            //         this.setState({selected_source: this.state.source_names[0]});
            //         source = this.state.source_names[0];
            //     }

            //     // this.setState({selected_source: this.state.source_names[0]}, () => {
            //     let items = [];
            //     if(source){
            //         items = this.state.items.filter((i) => i.source_id === source.id)
            //     }
            //     this.updateRows(items);
            //     // });
            // });     
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log('failed to fetch Product Stocks');
            this.props.isLoading(false);
            this.setState({loading: false});
        })
    }

    handleSourceSelection = (e, source) => {
		this.setState({selected_source: source}, () => {
            // let items = [];
            // if(this.state.selected_source){
            //     items = this.state.original_items.filter((i) => i.source_id === this.state.selected_source.id && i.name.toLowerCase().includes(this.state.searchText.toLowerCase()))
            // } 
            // // this.setState({items: items}, () => this.filterCriteria());
            // // this.setState({searchText: ""}, () => this.updateRows(items));
            // this.updateRows(items);
            this.fetchStock(source);
		});
	}

    sortBy = (event, property) => {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
		order = 'asc';
		}

		let items = this.state.items;
		if(order === 'asc'){
		    items.sort((a, b) => (a[orderBy] > b[orderBy]) ? 1 : -1);
		} else {
		    items.sort((a, b) => (a[orderBy] < b[orderBy]) ? 1 : -1);
		}
		
		this.setState({ order, orderBy,  items}, () => {
				this.updateRows(items);
		});
	}

    fetchProducts = () => {
        ProductService.getProductList()
        .then((data) => {
            this.setState({master_products: data.products}, () => this.fetchStock(this.state.selected_source));
        })
        .catch(error => {
            console.log(error);
        });
    }

    fetchSource = () => {
        Promise.all([WarehouseService.getWarehouseList(0, 999, "", "name", "asc"),  UserService.getAgentList()])
        .then((data) => {
            console.log(data);
            let source_names = [];
            let master_source = [];
            if(data[0] && data[0].warehouse.length > 0){
                // source_names = source_names.concat(data[0].warehouse.map((w) => (
                //     <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                // )));
                master_source = master_source.concat(data[0].warehouse);
            }
            if(data[1] && data[1].users.length > 0){
                // source_names = source_names.concat(data[1].users.map((w) => (
                //     <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                // )));
                master_source = master_source.concat(data[1].users);
            }
            source_names = master_source.map((element) => (
                ({key: element.id, id: element.id, value: element.name, type: element.type ?  "AGENT" : "WAREHOUSE",  label: element.type ? `${element.name} [Agent]` : `${element.name} [Warehouse]`})
            ));
            this.setState({master_source, source_names, selected_source: source_names[0]}, () => this.fetchProducts());
            this.props.isLoading(false);
            this.setState({loading: false});
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
            this.setState({loading: false});
        });
	}

    filterCriteria = (e) =>{
        this.props.isLoading(true);
        this.setState({loading: true});
        let searchText = "";
        if(e){
            e.preventDefault();
            searchText = e.target.value || "";
        } else {
            searchText = this.state.searchText;
        }
        let filteredList = this.state.original_items.filter(data => data.source_id === this.state.selected_source.id && data.name.toLowerCase().includes(searchText.toLowerCase()));
        if(searchText.length === 0){
            filteredList = this.state.original_items.filter(data => data.source_id === this.state.selected_source.id);
        }
        this.setState({
            searchText: searchText,
            items: filteredList,
            message: filteredList.length > 0 ? '' : 'No matching Product'
        });
        this.updateRows(filteredList);
        this.setState({loading: false});
        this.props.isLoading(false);
	}
	
	updateRows(data){
        let rows = [];
        let i = 0;
        data.forEach((item, index) => {
            // if(item.source_type === "WAREHOUSE"){
                if(item.status === 1 || (item.status === -1 && (item.fresh_stock > 0 || item.return_stock > 0))){
                    rows.push(<StockDetails key={index} index={++i} item={item} classes={this.props.classes}/>);
                }
            // } else {
            //     if(item.status === 1 || (item.status === -1 && (item.fresh_stock > 0 || item.return_stock > 0))){
            //         rows.push(<StockDetails key={index} index={++i} item={item} classes={this.props.classes}/>);
            //     }
            // }
        });
        this.setState({current_rows: rows});
    }

    render(){
        let {message, source_names, selected_source, loading} = this.state;
        let classes = this.props.classes;
        return (
            <div className="Home" style={{marginTop: 32}}>
                <Fade
                    in={loading}
                    style={{
                        transitionDelay: loading ? '10ms' : '0ms'
                    }}
                    unmountOnExit
                    >
                    <CircularProgress style={{position: "fixed", top: "50%", left: "50%", zIndex: 10}}/>
                </Fade>
                <div style={{display: "flex"}}>
					{/* <FormControl variant="outlined" className={clsx(classes.formControlLeft, classes.formControl)} style={{ float: "left", minWidth: 500}}>
                        <InputLabel
							ref={ref => {
							this.InputLabelRef = ref;
							}}
							htmlFor="outlined-warehouse-simple"
						>
							Source
						</InputLabel>
						<Select
							value={this.state.selected_source}
							onChange={this.handleSourceSelection}
                            disabled={this.props.loading}
							input={
							<OutlinedInput
								labelWidth={80}
								name="Warehouse"
								id="outlined-warehouse-simple"
							/>
							}
						>
							{this.state.source_names}
						</Select> */}
					{/* </FormControl> */}
                </div>
                <Paper className={classes.root} style={{width: "100%", marginTop: 10, paddingLeft: "5px", paddingRight: "5px"}}>
                    <EnhancedTableToolbar 
                        title={<Autocomplete
                            id="source-selection"
                            disableClearable
                            options={source_names}
                            getOptionLabel={option => option.label}
                            value={selected_source || null}
                            onChange={this.handleSourceSelection}
                            style={{ maxWidth: '50vw', minWidth: 300, zIndex: 9999 }}
                            disabled={this.props.loading}
                            renderInput={params => (
                                <TextField {...params} label="Source" variant="outlined" fullWidth />
                            )} />} 
                        exportReport={this.exportReport} 
                        refresh={this.refresh} 
                        onSearchTextChange={this.filterCriteria} 
                        searchText={this.state.searchText}/>
                    <Table className={classes.table} size="small">
                        <EnhancedTableHead
                            order={this.state.order}
                            orderBy={this.state.orderBy}
                            onRequestSort={this.sortBy}
                            rows ={this.state.columns} />
                        <TableBody>
                            {this.state.current_rows}
                        </TableBody>
                    </Table>
                    <div className={classes.message}>
                        {message}
                    </div>
                </Paper>
            </div>
        )
    }

}

class StockDetails extends Component {

    render(){
      const {item, index, classes} = this.props;

      let color = (item.fresh_stock === 0 && item.source_type === 'AGENT') || (item.fresh_stock > 0 && item.source_type === 'WAREHOUSE') ? "primary" : "secondary";
  
        return (
            <TableRow>
                <TableCell align="justify" scope="row" className={classes.tablecell}>
                    {index}
                </TableCell>
                <TableCell align="justify" scope="row" className={classes.tablecell}>
                    {item.name}
                </TableCell>
                <TableCell align="left" scope="row" className={classes.tablecell}>
                    {item.unit_size ? item.unit_size : ""}
                </TableCell>
                <TableCell align="right" className={classes.tablecell}>
                    <Typography variant="subtitle2" component="h6" color={color}>
                        {item.fresh_stock}
                    </Typography>
                </TableCell>
                <TableCell align="right" className={classes.tablecell}>
                    <Typography variant="subtitle2" component="h6" color={color}>
                        {item.return_stock}
                    </Typography>
                </TableCell>
                <TableCell align="right" className={classes.tablecell}>
                    {formatNumber(item.fresh_stock * item.unit_price)}
                </TableCell>
                <TableCell align="right" className={classes.tablecell}>
                    {formatNumber(item.return_stock * item.unit_price)}
                </TableCell>
            </TableRow>
        );
    }
  }

export default withStyles(styles)(InventoryStockSummary);